import { z } from 'zod';
import { validator } from '@xeppt/xeppt-sdk';
import { tagRegex } from '@const/regex';

interface IProps {
    messages: {
        first_name: string;
        last_name: string;
        birth_date: string;
        occupancy: string;
        tag: string;
        timezone: string;
    };
}

export const profileSettingsValidation = ({ messages }: IProps) => {
    const validationObject: any = {
        profile: z.object({
            first_name: validator.firstName(messages.first_name),
            last_name: validator.lastName(messages.last_name),
            // birth_date: validator.birthday(messages.birth_date),
            occupancy: z.string().min(1, { message: messages.occupancy }),
            tag: z.string().min(1, { message: messages.tag }),
            timezone: z.string().min(1, { message: messages.timezone })
        })
    };
    return z.object(validationObject);
};

interface IBusinessValidatorProps {
    messages: {
        company_name: string;
        tradingName: string;
        registration_number: string;
        category: string;
        size: string;
        website: string;
    };
}

export const businessSettingsValidation = ({ messages }: IBusinessValidatorProps) => {
    return z.object({
        company_name: z.string().min(1, { message: messages.company_name }),
        tradingName: z.string().min(1, { message: messages.tradingName }),
        registration_number: z.string().min(1, { message: messages.registration_number }),
        category: z.string().min(1, { message: messages.category }),
        size: z.string().min(1, { message: messages.size }),
        website: z.string().url({ message: messages.website })
    });
};
